import { render } from "./platforms.vue?vue&type=template&id=f1ba6d6c"
import script from "./platforms.vue?vue&type=script&lang=js"
export * from "./platforms.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__